import React from "react";
import { Hero, Table } from "../../components";
import ReactMarkdown from "react-markdown";
import rehypeKatex from "rehype-katex";
import rehypeRaw from "rehype-raw";
import remarkMath from "remark-math";

const TABLE_DATA = [
  {
    what: "Educational workshops “Villejuif respire” for children",
    forWhom: "For children",
    how: "Participation in summer activities organized by Villejuif city hall.",
    ref: React.createRef(),
    id: "villejuif",
  },
  {
    what: "Educational workshop in high school",
    forWhom: "For high school students",
    how: "Presentation of our project and organization of a workshop on innovative refeas.",
    ref: React.createRef(),
    id: "workshop",
  },
  {
    what: "Conferences, poster exhibition and afterworks in our campus",
    forWhom: "For undergraduate students",
    how: "Participation in events at SupBiotech to communicate on our project and sensibilize on many topics related to it.",
    ref: React.createRef(),
  },
  {
    what: "Scientific festival “Double Science”",
    forWhom: "For all",
    how: "Presentation of our project, discussions with diverse visitors, and pitch in front of the audience.",
    ref: React.createRef(),
  },
  {
    what: "Professional Forum EAU",
    forWhom: "For professionals",
    how: "Pitch of the project and discussion with professionals for the water sector.",
    ref: React.createRef(),
  },
  {
    what: "Professional Brochure",
    forWhom: "For professionals",
    how: "Sending of the brochure to professionals to introduce our project.",
    ref: React.createRef(),
  },
  {
    what: "Comic book",
    forWhom: "For children",
    how: "Realization of a comic strip to present the main refea of our project.",
    ref: React.createRef(),
  },
  {
    what: "Podcast Kesako",
    forWhom: "For young adults and students",
    how: "Recording of a podcast with Kezako podcast to present our project and synthetic biology.",
    ref: React.createRef(),
  },
  {
    what: "Mobile game",
    forWhom: "For all",
    how: "Conception of a mobile game to discover the principles of synthetic biology.",
    ref: React.createRef(),
  },
  {
    what: "Board game",
    forWhom: "For all",
    how: "Creation of a board game that involves graded questions on topics related to synthetic biology.",
    ref: React.createRef(),
  },
];

// TODO: Ne pas oublier les unitées + les titres :) (des %)
function Education() {
  const handleClick = (title: any) => {
    var h1Element = Array.from(document.querySelectorAll("h2")).find(
      (element) => {
        console.log(element.textContent, title);
        return element.textContent === title;
      }
    );

    // Check if the element was found
    if (h1Element) {
      // Do something with the selected <h1> element
      console.log(h1Element.textContent);
      h1Element.scrollIntoView({ behavior: "smooth" });
    } else {
      // The <h1> element with the specific text was not found
      console.log("No matching <h2> element found.");
    }
  };
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col z-8">
      <Hero title={"Education"}>
        Education shapes minds, fosters innovation, and{" "}
        <span className="text-lg font-black text-RougePastel md:text-xl lg:text-2xl">
          empowers
        </span>{" "}
        societies
      </Hero>

      <div className="flex w-full px-[24px] md:px-[70px] justify-center items-center">
        <div id="page-content" className="flex justify-center items-center mx-auto flex-col md:max-w-[1500px] gap-[30px] py-[50px]">
          <div
          >
            Realizing we could spread our enthusiasm of synthetic biology to our
            <b> local community</b>, our team focused on raising awareness about
            <b> global challenges</b> like water sanitation and climate change.
            Interacting with diverse stakeholders, we highlighted the importance
            of <b> greener heating solutions</b> and the risks of <b> endocrine
            disruptors</b>. Additionally, we showcased the potential of
            <b> synthetic biology</b> in tackling these issues and passionately
            shared our scientific enthusiasm, especially with children.
          </div>

          <Table data={TABLE_DATA} func={handleClick} />

          <ReactMarkdown
            className="w-full prose"
            remarkPlugins={[remarkMath]}
            rehypePlugins={[rehypeKatex, rehypeRaw]}
          >

            {`
## Educational workshops “Villejuif respire” for children
During the summer, we organized five workshops from July to August in collaboration with the city of
Villejuif. Our goal was to **showcase our project and raise awareness among young people about the
environment, synthetic biology, and issues related to endocrine disruptors.** We didn't just engage with
children, but also with students and their accompanying parents.
One of our workshops focused on **water treatment**, where participants could observe water treatment
processes at various sites and learn about [how water is treated](https://static.igem.wiki/teams/4577/wiki/human-practices/education/protocol-filtration.pdf) in purification plants. Another
workshop involved [extracting DNA from bananas](https://static.igem.wiki/teams/4577/wiki/human-practices/education/protocol-banana-dna-extraction.pdf), allowing us to introduce the concept of DNA to the
children. We also shared our comic book and conducted workshops provided by the CESEAU
association. Explaining our project brought us immense joy, especially when we received feedback from others.

<div class="image_frame horizontal">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/villejuif-respire2.jpeg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/villejuif-respire-1.jpg">
</div>

One of the highlights of this summer was witnessing the wonder in the eyes of my children as they saw
our **science in action**. We also discovered that many people were unaware of the risks associated with
endocrine disruptors, even though these substances pose real health threats, the extent of which is
still unknown to most. Furthermore, we found that people had limited knowledge about genetically
modified organisms (GMOs). This gave us the perfect opportunity to **dispel misconceptions** and offer
them insights beyond the biases they held.

## Educational workshop in high school

We were invited by a **high school** to present Clean Heat and introduce synthetic biology to the students.
Subsequently, we encouraged the students to think about a **synthetic biology project** that could address
a current issue. Some imagined how to become spider-man or cure cancer with a gene from the elephant
!

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/highschool.jpg">
</div>

Overall, this experience was **mutually enriching**. We had the chance to share our passion for synthetic 
biology and inspire the next generation of scientists. 

## Conferences, poster exhibition and afterworks in our campus

Throughout the year, we organized a variety of events on our campus, each designed to engage and
educate our fellow students. The first event took place during the **Nature Festival in May**, where we
hosted a conference on endocrine disruptors. It was a compelling opportunity to shed light on the real
risks associated with these disruptors and the **lack of viable solutions**, especially regarding EE2.

In June, we repeated the experience during **SupBiotech's Innovation Challenge Day**. This time, we faced
a barrage of insightful questions from fellow students. They expressed particular interest in the iGEM
project, which was not widely known at the time. This was followed by a **poster session** where we showcased
our project to third and fourth-year SupBiotech students.

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/conferences-poster-exhibition-and-afterworks-1.jpeg">
</div>

Finally, in September, we organized another conference, this time in front of over a hundred students,
focusing on synthetic biology for the second-year students at SupBiotech. For this occasion, we invited
another **iGEM team Evry-Paris-Saclay** to introduce students to another realm of synthetic biology:
health, in addition to the environment. We also invited professors to attend the conference, enabling
them to ask questions and provide valuable feedbacks. The students displayed a keen interest in the
topic, and we hope that this enthusiasm translates into future participation in iGEM teams. 

<div class="image_frame horizontal">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/conferences-poster-exhibition-and-afterworks-2.jpeg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/conferences-poster-exhibition-and-afterworks-3.jpeg">
</div>

## Scientific festival “Double Science”
In May, we participated in the **Double Science Festival** held in Paris, where numerous stands showcased
a wide range of scientific topics. We set up our own stand with a poster presenting our project and a
**microscope displaying microalgae cells**. This setup allowed us to engage with a diverse audience,
including individuals with various scientific backgrounds and curious children. 

<div class="image_frame horizontal">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/double-science-1.jpeg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/double-science-2.jpeg">
</div>

Many visitors were **pleasantly surprised** to see students presenting an environmental project. While
some were aware of the issue of endocrine disruptors, they were unaware of the complexities involved
in finding interventions. Additionally, some visitors expressed concerns about GMOs, providing us with
an opportunity to **dispel misconceptions** and demonstrate that it is possible to find safe solutions using
GMOs.

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/double-science-3.jpeg">
</div>

To culminate the weekend, we took our project to the **stage**, where a photobioreactor loaned by our
partner, **Synoxis Algae**, was showcased. The audience asked thought-provoking questions and later
visited our stand, expressing their enthusiasm for our project.

The festival atmosphere was vibrant, filled with music and a **shared passion** for science. It was a
testament to the power of scientific outreach and education, leaving us inspired and motivated to
continue our efforts in promoting environmental awareness and innovative solutions.

## Professional Forum EAU
In March, at the beginning of our project, we attended a **professional forum** organized by the **EMS
Cluster**, an association gathering companies from the environemental field. It was a pivotal opportunity
to showcase our project for one of the first times and **connect with professionals** in the water sector.
We introduced professionals to the potential of synthetic biology for various applications, notably in
the fields of **heat production** and **water treatment**.

<div class="image_frame horizontal">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/forum-eau-1.jpeg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/forum-eau-2.jpeg">
</div>

## Professional Brochure
At the beginning of our project, we created a [booklet](https://static.igem.wiki/teams/4577/wiki/human-practices/education/pitch-cleanheat-igem-ionis-paris-2023.pdf) to connect with professionals. Additionally, we
believe it's a technique to **raise awareness** about synthetic biology and environmental issues within
the professional community. It serves as a perfect example of a solution enabling a **positive impact** on
both society and the environment.

## Podcast Kesako
We were invited to participate to **Kesako podcast**, a scientific podcast for **young adults.** We were able
to present our project and explain the use of synthetic biology.

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/kesako-podcast.jpg">
</div>

## Comic book
An important challenge we faced was explaining our project in the simplest way possible. What could
be easier than a **comic book**? Available in both [French](https://static.igem.wiki/teams/4577/wiki/human-practices/education/comic-book-french-version.pdf) and [English](https://static.igem.wiki/teams/4577/wiki/human-practices/education/comic-book-english-version.pdf), this comic book allowed us to convey
our project to both **young** and **adult** audiences.

<div class="image_frame">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/comic-book-extrait.jpg">
</div>

## Mobile game : Plasmide
To ensure a fun exploration of synthetic biology, we created a mobile game that transforms your phone
into a pocket-sized lab. This game enables players to integrate specific genes into their chosen
microorganisms to create a final super microorganism. Players learn biology techniques and
microorganism characteristics along the way! This game is available on [GitLab](https://gitlab.igem.org/2023/software-tools/ionis-paris/-/tree/main/app/app?ref_type=heads) and on [Google Play](https://play.google.com/store/apps/details?id=com.chaiche.plasmide&pcampaignid=web_share).
<div class="image_frame horizontal no_wrap">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/appli-1.jpeg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/appli-2.jpeg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/appli-3.jpeg">
</div>

## Board game
Our team can never have enough funny games. Luckily, we've developed a board game. We conceived
a general knowledge game inspired by 'Tu te mets combien?' focusing on four biology themes: history,
techniques, microorganisms, plants, and safety. Questions vary in difficulty, and the higher the difficulty
level chosen, the more spaces you can advance if the answer is correct. We tested the board game at
the Villejuif City Association Forum and during a campus student night. The feedback was positive: it's
an engaging game that facilitates learning biology at all levels.

<div class="image_frame horizontal">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/jeu-societe-1.jpg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/jeu-societe-2.jpg">
</div>

You want to try the game ? Download and play it here: 
- English version : 
  - [Rules in english](https://static.igem.wiki/teams/4577/wiki/human-practices/education/anglais-1.pdf)
  - [Board in english](https://static.igem.wiki/teams/4577/wiki/human-practices/education/boardgame-board-eng.pdf)
  - [Cards in english](https://static.igem.wiki/teams/4577/wiki/human-practices/education/boardgame-cards-eng.pdf)
- French version : 
  - [Rules in french](https://static.igem.wiki/teams/4577/wiki/human-practices/education/rules-boardgame-fr.pdf)
  - [Board in french](https://static.igem.wiki/teams/4577/wiki/human-practices/education/boardgame-board-fr.pdf)
  - [Cards in french](https://static.igem.wiki/teams/4577/wiki/human-practices/education/boardgame-cards-fr.pdf)

## Communication on social media
In the end, it's essential for us to engage in **social media communication**. Not only did it assist in
fundraising, but it also provided an opportunity to raise awareness about current issues, synthetic
biology, and the iGEM competition to our followers.

<div class="image_frame horizontal">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/reseaux-sociaux-1.jpg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/reseaux-sociaux-3.jpg">
    <img class="illustration medium" src="https://static.igem.wiki/teams/4577/wiki/human-practices/education/reseaux-sociaux-2.jpg">
</div>

In conclusion, working on the Education aspect for iGEM has been incredibly **fulfilling**. It allowed us to
share our passion and engage in discussions about important issues. Being able to address diverse
audiences and tailor our message accordingly is crucial. We believe we **made an impact** in our local
community, within our school, in Villejuif, and on social media. While reaching everyone might be
impossible, the **collective effort of all iGEM teams** has allowed us to reach a significant portion of the
population.
`}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default Education;
